import { useMediaQuery } from "."

const useIsSm = () => useMediaQuery("(min-width:576px)")
const useIsMd = () => useMediaQuery("(min-width:768px)")
const useIsLg = () => useMediaQuery("(min-width:992px)")

export { useIsLg, useIsMd, useIsSm }
